// extracted by mini-css-extract-plugin
export var cardHeader = "_i7-0";
export var reorderHandle = "_i7-3";
export var titleArea = "_i7-1";
export var titleAreaWithHandle = "_i7-2";